'use client';

import { AppContextProvider } from '@/components/App';
import ToastContainer from '@/components/ToastContainer';
import { siteConfigIds } from '@/constants/site-config-ids';
import { useAdapter } from '@/hooks/Adapter/useAdapter';
import { ApolloProvider } from '@apollo/client';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import SyncCartWrapper from '../sync-cart-wrapper';
import { SearchParamsRecorder } from './search-params-recorder';
import { useGA4 } from './use-ga4';
import { useGTM } from './use-gtm';

const GlobalRemindDialogLazyLoad = dynamic(() => import('@/components/global-remind-dialog-lazy-load'), { ssr: false });
const GlobalBackToTop = dynamic(() => import('@/components/global-back-to-top'), { ssr: false });
const ServerNavigateLoading = dynamic(() => import('@/components/server-navigate-loading'), { ssr: false });
const DressStyleRecommendation = dynamic(() => import('@/components/dress-style-recommendation'), { ssr: false });
const MapleLeafCode = dynamic(() => import('@/components/maple-leaf-code'), { ssr: false });

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (str, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }

    // If a string
    return this.replace(new RegExp(str, 'g'), newStr);
  };
}

const Adapter = props => {
  const { children } = props;

  const { apolloProps, reduxProps } = useAdapter(props);

  const pathname = usePathname();

  useGTM({ id: siteConfigIds.gtmId });

  useGA4();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return (
    <ApolloProvider {...apolloProps}>
      <ReduxProvider {...reduxProps}>
        <AppContextProvider>
          <SyncCartWrapper>{children}</SyncCartWrapper>
          <GlobalBackToTop />
          <ToastContainer />
          <ServerNavigateLoading />
          {false && <GlobalRemindDialogLazyLoad />}
          <DressStyleRecommendation />
          <MapleLeafCode />
          <Suspense>
            <SearchParamsRecorder />
          </Suspense>
        </AppContextProvider>
      </ReduxProvider>
    </ApolloProvider>
  );
};

export default Adapter;
